<template>
  <v-container v-if="!isMobile">
    <nav>
      <v-app-bar app height="80">
        <v-toolbar-title>
          <v-breadcrumbs :items="items" large></v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-md-date-range-picker :presets="presets" opens="right" @change="updateData">
          <v-card class="pa-3" slot="input">
            <v-icon color="red darken-2"> mdi-clock-outline </v-icon>
            <span style="font-size: 15px;">{{ formatDate(this.$store.state.dateTime1) }} - {{ formatDate(this.$store.state.dateTime2) }}</span>
          </v-card>
        </v-md-date-range-picker>
      </v-app-bar>
    </nav>

    <v-col cols="6" md="2">
      <v-card class="pa-2" outlined tile> {{ boardName.slice(-1)[0] }} | {{ phase.slice(-1)[0] }} </v-card>
    </v-col>

    <v-row>
      <v-col v-if="board.length == 0">
        <v-row class="fill-height" align-content="center" justify="center">
          <v-col class="text-subtitle-1 text-center" cols="12">
            No Data
          </v-col>
        </v-row>
      </v-col>
      <v-col v-else>
        <v-container style="height: 200px;" v-if="loading">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Getting your chart
            </v-col>
            <v-col cols="6">
              <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
        <apexchart width="800" height="400" type="line" :options="currentChart" :series="currentSeries" v-else></apexchart>
      </v-col>
      <v-col v-if="board.length == 0">
        <v-row dense>
          <v-col>
            <p class="mx-auto text-center" style="font-size:12px">Current</p>
            <v-card class="mx-auto text-center" max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black">
                  Recently
                </div>
                <div style="font-size:18px;color:black">
                  No Data
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" max-width="200" max-height="100">
              <div style="font-size:12px;color:black">
                Peak
              </div>
              <div style="font-size:14.5px;color:black">
                No Data
              </div>
            </v-card>
            <v-card class="mx-auto text-center" max-width="200" max-height="100">
              <div style="font-size:12px;color:black">
                Min
              </div>
              <div style="font-size:14.5px;color:black">
                No Data
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="phaseLabel.slice(-1)[0] === 'R'">
        <v-row dense>
          <v-col>
            <p class="mx-auto text-center" style="font-size:12px">Current</p>
            <v-card class="mx-auto text-center" color="red" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px">
                  Recently
                </div>
                <div style="font-size:18px">{{ amp.slice(-1)[0] }}<span style="font-size:10px">A</span></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="red" dark max-width="200" max-height="100">
              <div style="font-size:12px">
                Peak
              </div>
              <div style="font-size:14.5px">{{ Math.max(...amp) }}<span style="font-size:10px">A</span></div>
            </v-card>
            <v-card class="mx-auto text-center" color="red lighten-3" dark max-width="200" max-height="100">
              <div style="font-size:12px">
                Min
              </div>
              <div style="font-size:14.5px">{{ Math.min(...amp) }}<span style="font-size:10px">A</span></div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col v-if="phaseLabel.slice(-1)[0] === 'Y'">
        <v-row dense>
          <v-col>
            <p class="mx-auto text-center" style="font-size:12px;color:black;">
              Current
            </p>
            <v-card class="mx-auto text-center" color="yellow" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Recently
                </div>
                <div style="font-size:18px;color:black;">{{ amp.slice(-1)[0] }}<span style="font-size:10px;color:black;">A</span></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="yellow" dark max-width="200" max-height="100">
              <div style="font-size:12px;color:black;">
                Peak
              </div>
              <div style="font-size:14.5px;color:black;">{{ Math.max(...amp) }}<span style="font-size:10px;color:black;">A</span></div>
            </v-card>
            <v-card class="mx-auto text-center" color="yellow lighten-3" dark max-width="200" max-height="100">
              <div style="font-size:12px;color:black;">
                Min
              </div>
              <div style="font-size:14.5px;color:black;">{{ Math.min(...amp) }}<span style="font-size:10px;color:black;">A</span></div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col v-if="phaseLabel.slice(-1)[0] === 'B'">
        <v-row dense>
          <v-col>
            <p class="mx-auto text-center" style="font-size:12px">Current</p>
            <v-card class="mx-auto text-center" color="blue" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px">
                  Recently
                </div>
                <div style="font-size:18px">{{ amp.slice(-1)[0] }}<span style="font-size:10px">A</span></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="blue" dark max-width="200" max-height="100">
              <div style="font-size:12px">
                Peak
              </div>
              <div style="font-size:14.5px">{{ Math.max(...amp) }}<span style="font-size:10px">A</span></div>
            </v-card>
            <v-card class="mx-auto text-center" color="blue lighten-3" dark max-width="200" max-height="100">
              <div style="font-size:12px">
                Min
              </div>
              <div style="font-size:14.5px">{{ Math.min(...amp) }}<span style="font-size:10px">A</span></div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

  <div v-else>
    <div class="mt-5 pa-1">
      <div class="pa-1">
        <v-card style="text-align:left; display:flex; justify-content:space-between;">
          <v-md-date-range-picker :presets="presets" opens="left" @change="updateData">
            <v-card class="pa-3" slot="input" flat>
              <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px; margin-left: 5px;">{{ formatDate(this.$store.state.dateTime1) }} - {{ formatDate(this.$store.state.dateTime2) }}</span>
            </v-card>
          </v-md-date-range-picker>
        </v-card>
        <div class="mt-2">
          <v-card class="pa-2" justify="center" align="center" outlined> {{ boardName.slice(-1)[0] }} | {{ phase.slice(-1)[0] }} </v-card>
        </div>
      </div>
    </div>
    <v-container>
      <v-row>
        <v-col cols="12" v-if="board.length == 0">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              No Data
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-else>
          <v-container style="height: 200px;" v-if="loading">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                Getting your chart
              </v-col>
              <v-col cols="6">
                <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
          <apexchart height="250" type="line" :options="currentChart" :series="currentSeries" v-else></apexchart>
        </v-col>
        <v-col v-if="board.length == 0">
          <v-row dense>
            <v-col>
              <p class="mx-auto text-center" style="font-size:12px">Current</p>
              <v-card class="mx-auto text-center" max-width="200" max-height="100">
                <v-card-text>
                  <div style="font-size:12px;color:black">
                    Recently
                  </div>
                  <div style="font-size:18px;color:black">
                    No Data
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center" max-width="200" max-height="100">
                <div style="font-size:12px;color:black">
                  Peak
                </div>
                <div style="font-size:14.5px;color:black">
                  No Data
                </div>
              </v-card>
              <v-card class="mx-auto text-center" max-width="200" max-height="100">
                <div style="font-size:12px;color:black">
                  Min
                </div>
                <div style="font-size:14.5px;color:black">
                  No Data
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="phaseLabel.slice(-1)[0] === 'R'">
          <v-row dense>
            <v-col>
              <p class="mx-auto text-center" style="font-size:12px">Current</p>
              <v-card class="mx-auto text-center" color="red darken-1" dark max-width="200" max-height="100">
                <v-card-text>
                  <div style="font-size:12px">
                    Recently
                  </div>
                  <div style="font-size:18px">{{ amp.slice(-1)[0] }}<span style="font-size:10px">A</span></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center mb-1" color="red lighten-1" dark max-width="200" max-height="100">
                <div style="font-size:12px">
                  Peak
                </div>
                <div style="font-size:14.5px">{{ Math.max(...amp) }}<span style="font-size:10px">A</span></div>
              </v-card>
              <v-card class="mx-auto text-center" color="red lighten-2" dark max-width="200" max-height="100">
                <div style="font-size:12px">
                  Min
                </div>
                <div style="font-size:14.5px">{{ Math.min(...amp) }}<span style="font-size:10px">A</span></div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="phaseLabel.slice(-1)[0] === 'Y'">
          <v-row dense>
            <v-col>
              <p class="mx-auto text-center" style="font-size:12px;color:black;">
                Current
              </p>
              <v-card class="mx-auto text-center" color="yellow" dark max-width="200" max-height="100">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recently
                  </div>
                  <div style="font-size:18px;color:black;">{{ amp.slice(-1)[0] }}<span style="font-size:10px;color:black;">A</span></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center" color="yellow" dark max-width="200" max-height="100">
                <div style="font-size:12px;color:black;">
                  Peak
                </div>
                <div style="font-size:14.5px;color:black;">{{ Math.max(...amp) }}<span style="font-size:10px;color:black;">A</span></div>
              </v-card>
              <v-card class="mx-auto text-center" color="yellow lighten-3" dark max-width="200" max-height="100">
                <div style="font-size:12px;color:black;">
                  Min
                </div>
                <div style="font-size:14.5px;color:black;">{{ Math.min(...amp) }}<span style="font-size:10px;color:black;">A</span></div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="phaseLabel.slice(-1)[0] === 'B'">
          <v-row dense>
            <v-col>
              <p class="mx-auto text-center" style="font-size:12px">Current</p>
              <v-card class="mx-auto text-center" color="blue" dark max-width="200" max-height="100">
                <v-card-text>
                  <div style="font-size:12px">
                    Recently
                  </div>
                  <div style="font-size:18px">{{ amp.slice(-1)[0] }}<span style="font-size:10px">A</span></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center" color="blue" dark max-width="200" max-height="100">
                <div style="font-size:12px">
                  Peak
                </div>
                <div style="font-size:14.5px">{{ Math.max(...amp) }}<span style="font-size:10px">A</span></div>
              </v-card>
              <v-card class="mx-auto text-center" color="blue lighten-3" dark max-width="200" max-height="100">
                <div style="font-size:12px">
                  Min
                </div>
                <div style="font-size:14.5px">{{ Math.min(...amp) }}<span style="font-size:10px">A</span></div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  import moment from "moment";
  import VueApexCharts from "vue-apexcharts";

  Vue.component("apexchart", VueApexCharts);

  export default {
    data: () => ({
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Energy",
          disabled: true,
          href: "",
        },
        {
          text: "Usage By DB",
          disabled: false,
          href: "/usage-by-db-energy",
        },
        {
          text: "F Channel",
          disabled: true,
          href: "",
        },
      ],
      // values1: moment().subtract(24, "hour"),
      // values2: moment(),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment()],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment()],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment()],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [moment().subtract(6, "day"), moment()],
        },
        {
          label: "Last Week",
          range: [moment().subtract(13, "day"), moment().subtract(7, "day")],
        },
        {
          label: "This Month",
          range: [moment().startOf("month"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month"), moment().subtract(1, "month")],
        },
      ],
      isMobile: true,
      loading: true,
      board: [],
      boardName: [],
      phase: [],
      phaseLabel: [],
      amp: [],
      currentChart: {
        chart: {
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          tooltip: {
            enabled: false,
          },
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },

        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: "top",
        },
        yaxis: {
          axisTicks: {
            show: true,
          },
          labels: {
            formatter: (val) => {
              return val.toFixed(2) + "A";
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
      },
      currentSeries: [
        {
          data: [],
        },
      ],
    }),
    mounted() {
      this.loadsBoard();
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });
    },
    methods: {
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      formatDate(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      loadsBoard: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/ecms/" + this.$route.params.id + "/C_2F/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.board = res.data;
            this.amp = res.data.map((amp) => amp.fields.C_2F.value);
            this.boardName = res.data.map((boardName) => boardName.fields.C_2F.boardName);
            this.phaseLabel = res.data.map((phase) => phase.fields.C_2F.ryb.phase);
            this.phase = res.data.map((label) => label.fields.C_2F.ryb.label);

            let current = this.board.map((e) => {
              return {
                x: e.timestamp,
                y: e.fields.C_2F.value,
              };
            });

            this.currentSeries = [
              {
                name: "Current",
                data: current,
              },
            ];
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loading = false));
      },
      updateData(values) {
        this.values1 = values[0];
        this.values2 = values[1];
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);
        this.loadsBoard();
        this.loading = true;
      },
    },
  };
</script>
